import { Link, useLocation } from "react-router-dom";
import LifeTime from "../smallComponent/LifeTime";
import BackBtn from "../smallComponent/BackBtn";

const CommonNavBar = ({ pageTitle, calender, backBtn }) => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  // -----------Path name set is end----------
  return (
    <div className="mx-auto flex items-center justify-between bg-white">
      <nav aria-label="breadcrumb">
        <h1 className="mb-2 font-poppins text-[23px] font-semibold text-secondBlack md:text-[24px] lg:text-[30px]">
          {pageTitle ? pageTitle : "Customer Profile"}
        </h1>
        <ol className="breadcrumb flex flex-col gap-[2px] space-x-2 pl-[2px] xs:flex-row xs:gap-3">
          <Link
            to="/my-task"
            className="breadcrumb-item font-poppins text-[15px] font-medium capitalize text-blue-500 hover:underline md:text-[17px]"
          >
            <span className="mr-1 inline text-gray-500 xs:hidden">{">"}</span>
            My Task
          </Link>
          {pathnames.map((name, index) => {
            const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
            const isLast = index === pathnames.length - 1;
            const displayName =
              name.length > 20
                ? name.replace(name, "").replace("-", " ")
                : name.replace("-", " ");

            const locaTionName = displayName.replace("-", " ");

            return (
              <li
                className="breadcrumb-item !ml-0 mt-[1px] flex items-center font-poppins text-[15px] font-medium capitalize md:text-[17px]"
                key={name}
              >
                {locaTionName ? (
                  <span className="mr-1 text-gray-500">{">"}</span>
                ) : (
                  ""
                )}
                {isLast ? (
                  <span className="text-gray-500">{locaTionName}</span>
                ) : name.length > 20 ? (
                  <span className="text-red-500">{locaTionName}</span>
                ) : (
                  <Link
                    to={
                      locaTionName === "loan request" ||
                      locaTionName === "profile" ||
                      locaTionName === "setting" ||
                      locaTionName === "loan" ||
                      locaTionName === "user profile"
                        ? ""
                        : routeTo
                    }
                    className={`${
                      locaTionName === "loan request" ||
                      locaTionName === "profile" ||
                      locaTionName === "setting" ||
                      locaTionName === "loan" ||
                      locaTionName === "user profile"
                        ? "text-gray-500"
                        : " text-blue-500 hover:underline"
                    }`}
                  >
                    {locaTionName}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
      <div>
        {calender === false ? backBtn ? <BackBtn /> : <LifeTime /> : ""}
      </div>
    </div>
  );
};

export default CommonNavBar;
